// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"8b57d46e","233":"126bf188","559":"51d1588d","660":"f3b8a700","697":"88a0e4e9","774":"e535cbc7","823":"0ca2e9f2","842":"219ff32d","957":"5a97e09d"}[chunkId] + ".chunk.js";
};